import React from "react";
import ConfigSection from "../../ConfigSection";

const QualificationSelection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Qualification'
      configType='Qualification'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default QualificationSelection;
